import React from 'react';
import { Star } from 'lucide-react';

const ClientReview = ({ review }) => {
  if (!review) return null;

  return (
    <div className="bg-white border rounded-lg p-2 sm:p-3">
      <h3 className="text-sm sm:text-base font-bold text-black mb-2 sm:mb-3">Client Review</h3>
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-2 sm:p-3">
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
          <div className="flex flex-shrink-0">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star
                key={star}
                className={`w-3.5 h-3.5 sm:w-4 sm:h-4 ${
                  star <= review.rating
                    ? 'text-yellow-400 fill-yellow-400'
                    : 'text-gray-300'
                }`}
              />
            ))}
          </div>
          <span className="text-xs sm:text-sm font-medium text-black break-words">
            {review.title}
          </span>
        </div>
        <p className="text-xs text-gray-600 mb-1 break-words">{review.comment}</p>
        {!review.is_approved && (
          <p className="text-xs text-gray-500 italic">Pending approval</p>
        )}
      </div>
    </div>
  );
};

export default ClientReview;

